import { Section } from "@interia/common/components/section";
import { H1, H2, P, parsedHtml } from "@interia/common/components/typography";
import { palette } from "@interia/common/styles/global";
import styled from "styled-components";
import { up, down } from 'styled-breakpoints';
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { ButtonArrow } from "@interia/common/components/shapes";

export const Wrapper = styled(Section)`
`

export const HeaderWrapper = styled(Section)`
  background-image: url('/mission-background.png');
  color: ${palette.white};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: center;
  ${down('md')}{
    grid-template-columns: 1fr;
  }
`

export const Background = styled.div`
 position: absolute;
 z-index: -3;
 top:0;
 left:0;
 height:100%;
 width: 100%;
`

export const Title = styled(H1)`
  margin-top: 1rem;
  font-size: 3.75rem;
  letter-spacing: -1.2px;
  font-weight: 300;
  line-height: 1;
`

export const Description = styled(parsedHtml)`
margin: 0;
>p{
  margin:0;
}
`

export const TextImage = styled(GatsbyImage)`
  margin-left: 1rem;
  margin-bottom: 1rem;
  max-width: 50%;
  float: right;
`

export const AboveTextImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  
`

export const AboveTextImage = styled(GatsbyImage)`
  object-fit: contain;
`

export const NavWrapper = styled(Section)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const LinkWrapper = styled.div`

`

export const NavLink = styled(Link)`
  font-size: 1.25rem;
  color: #00DFB8;
  text-decoration: none;
`

export const NavLinkArrow = styled.figure`
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  margin: 0;
  margin-bottom: 0.1rem;
  border-top: 2px solid ${props => props.color};
  border-left: 2px solid ${props => props.color};
  color: #00DFB8;
`